import { render, staticRenderFns } from "./FilterGlossaryCulture.vue?vue&type=template&id=90262d08&scoped=true&"
import script from "./FilterGlossaryCulture.vue?vue&type=script&lang=js&"
export * from "./FilterGlossaryCulture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90262d08",
  null
  
)

export default component.exports